module.exports = __webpack_public_path__ + "img/bg-datausing.f54bc751.jpg";